interface ManualLegendProps {
  label: string;
  items?: Array<{
    label: string;
    color: string;
  }>;
}

export function ManualLegend({
  label,
  items = [{ label, color: "#ffa500" }],
}: ManualLegendProps) {
  return (
    <>
      {items.map((item) => (
        <div key={item.label} className="flex items-center mb-3 last:mb-0 gap-3">
          <div
            className="min-w-[30px] w-[30px] h-0 my-2.5 flex-shrink-0"
            style={{ borderTop: `3px solid ${item.color}` }}
          />
          <span className="text-[13px] text-gray-light leading-tight">
            {item.label}
          </span>
        </div>
      ))}
    </>
  );
}

export default ManualLegend;
